import { getDynamicCurrency } from '@/util-conversion/currency/currency-to-string';

interface CarSalesProceedsProps {
  tradeInValue: number;
  carSalesProceeds: number;
  remainingLoanBalance: number;
  ownershipYearsToDate: number;
  ownershipYears: number;
}

export default function CarSalesProceeds({
  tradeInValue,
  carSalesProceeds,
  remainingLoanBalance,
  ownershipYearsToDate,
  ownershipYears,
}: CarSalesProceedsProps) {
  const overFiveYearOwnership = ownershipYears >= 5;

  return (
    <>
      {overFiveYearOwnership ? (
        <p className="text-left text-xs font-normal leading-4 text-flexcar-neutral50">
          If you were to buy an identical used car, you would receive{' '}
          {getDynamicCurrency(carSalesProceeds)} after selling it in{' '}
          {ownershipYearsToDate}, based on Black Book estimates of its resale value.
        </p>
      ) : null}

      {!overFiveYearOwnership && carSalesProceeds >= 0 ? (
        <p className="text-left text-xs font-normal leading-4 text-flexcar-neutral50">
          If you were to buy an identical used car, you would receive{' '}
          {getDynamicCurrency(carSalesProceeds)} after selling it in{' '}
          {ownershipYearsToDate}, based on Black Book estimates of the car’s resale value
          of {getDynamicCurrency(tradeInValue)}, minus your remaining loan balance of{' '}
          {getDynamicCurrency(remainingLoanBalance)}.
        </p>
      ) : null}

      {!overFiveYearOwnership && carSalesProceeds < 0 ? (
        <p className="text-left text-xs font-normal leading-4 text-flexcar-neutral50">
          If you were to buy an identical used car, you would still owe approximately{' '}
          {getDynamicCurrency(Math.abs(carSalesProceeds))} after selling it in{' '}
          {ownershipYearsToDate}, as the remaining loan balance of{' '}
          {getDynamicCurrency(remainingLoanBalance)} would be greater than the car’s
          resale value of {getDynamicCurrency(tradeInValue)}, based on Black Book
          estimates.
        </p>
      ) : null}
    </>
  );
}
